import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ChatHelp20Regular } from '@vicons/fluent';
import { HelpBuoyOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils';
const IFrame = () => import('@/views/iframe/index.vue');

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/helpdesk',
    name: 'helpdesk',
    component: Layout,
    redirect: '/helpdesk/ticket',
    meta: {
      title: 'Helpdesk',
      icon: renderIcon(HelpBuoyOutline),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['helpdesk', 'helpdesk_ticket_read'],
      sort: 10,
    },
    children: [
      {
        path: 'ticket',
        name: 'helpdesk_ticket',
        meta: {
          title: 'Ticket',
          prefix: 'Helpdesk',
          icon: renderIcon(ChatHelp20Regular),
          hidden: true,
          //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
          permissions: ['helpdesk_ticket_read'],
        },
        component: () => import('@/views/helpdesk/ticket/index.vue'),
      },
      {
        path: 'helpdesk_report',
        name: 'helpdesk_report',
        meta: {
          title: 'Report',
          icon: renderIcon(HelpBuoyOutline),
          permissions: ['helpdesk_ticket_read'],
          affix: true,
          hidden: false,
          frameSrc: 'https://support.navidata.ca/',
        },
       // component: () => import('@/views/dashboard/console/console.vue'),
       component: IFrame,
      },
    ],
  },
];

export default routes;
